export const ADD_TOKEN__INFO = "ADD_TOKEN__INFO";
export const DO_LOGOUT = "DO_LOGOUT";
export const RESET_TOKENS = "RESET_TOKENS";
export const ADD_DOCS = "ADD_DOCS";
export const START_TIMER = "START_TIMER";




export const resetTokens = () => {
  return {
    type: RESET_TOKENS,
    
  };
};


export const initiateTimer = () => {
  return {
    type: START_TIMER,
    
  };
};

export const migrateInfo = (data) => {
  return {
    type: ADD_TOKEN__INFO,
    data,
  };
};

export const addDocInfo = (data) => {
  return {
    type: ADD_DOCS,
    data,
  };
};

export const addTokenInfo = (data) => {
  return {
    type: ADD_TOKEN__INFO,
    data,
  };
};

export const doLogout = (data) => {
  return {
    type: DO_LOGOUT,
    data,
  };
};



